const styles = {
  content: {
    padding: "3%",
  },
  button: {
    marginTop: "20px",
    textAlign: "center",
  },
  textArea: {
    width: "205%",
  },
  firstRow: {
    display: "flex",
    flexDirection: "row",
  },
  textFieldContainer: {
    width: "50%",
    padding: "0 1%",
    marginBottom: "1em",
  },
  textField: {
    width: "100%",
  },
  rightTextField: {
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dropdown: {
    width: "30%",
  },
  tableToolBar: {
    marginLeft: "2em",
    marginBottom: "1em",
  },
  paper: {
    padding: "1em",
  },
  title: {
    fontWeight: "bold",
  },

  weekList: {
    marginTop: "1em",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },

  weekdropdown: {
    width: "50%",
    marginRight: "1em",
  },

  weekItem: {
    padding: '10px',
    marginRight: '10px',  
    minWidth: '120px',    
  },

  weekItemBox: {
    marginTop: '10px',
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  }
};

export default styles;
